module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    on: {
      "click": _vm._click
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b87b3b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/checkbox-group.vue
// module id = 701
// module chunks = 85